import React from "react";
import Icon from "../icons/Icons";
import "./Services.css";

const services = [
  {
    icon: "cloud",
    title: "Cloud Management",
    description:
      "Our team of AWS experts guides companies to operate on the cloud to enable a new level of automation, cost optimization, capacity overflow, failover, policy enforcement and portability.",
  },
  {
    icon: "chip",
    title: "Secure AI Solutions",
    description:
      "Leverage your own data and network to interact with AI models, enhancing control and customization in your AI-driven solutions.",
  },
  {
    icon: "zap",
    title: "Serverless Architecture",
    description:
      "Serverless computing helps companies shift more of the traditional operational responsibilities to cloud providers and enjoy the true benefits of running on the cloud.",
  },
  {
    icon: "shield",
    title: "Compliance Readiness",
    description:
      "Prepare for compliance with the Health Insurance Portability and Accountability Act (HIPAA) and/or the Service Organization Control 2 (SOC2) framework.",
  },
  {
    icon: "loop",
    title: "DevOps",
    description:
      "Improve the speed, stability, availability, and security of your software delivery capability by using modern DevOps technologies.",
  },
  {
    icon: "chart",
    title: "Cost Optimization",
    description:
      "FinOps helps organizations optimize cloud spending by managing costs, increasing accountability, and promoting collaboration between finance, operations, and development teams.",
  },
];

const Services = () => {
  return (
    <section id="expertise" className="section">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">what we do</p>
          <h2 className="h2">Our areas of expertise</h2>
        </div>
        <div className="expertise-grid">
          {services.map((service, i) => (
            <article className="card card-hover expertise-card" key={service.title}>
              <div className="expertise-card-top">
                <div className="icon-tile">
                  <Icon name={service.icon} />
                </div>
                <span className="expertise-index">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="h3">{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
